<template>
    <div class="pay-row">
      <div class="loading" style="display: flex !important; align-items: center; flex-direction: column; position: fixed; left: 50%; top: 50%; transform: translate(-50%, -50%); }">
        <b-spinner style="margin-bottom:20px; width: 3rem; height: 3rem;display:block !important" label="Large Spinner"></b-spinner>
        Yönlendiriliyorsunuz...
      </div>
      <form :action="form.url" method="post">
        <input v-for="(item,name) in form" :name="name" :value="item" :key="name" type="hidden">
        <button style="opacity:0" id="button_pay" type="submit"></button>
      </form>
    </div>
</template>

<script>
  export default{
    computed:{
      form(){
        return this.$route.query
      }
    },
    created(){
      setTimeout(() => {
        document.getElementById("button_pay").click();
      }, 2000);
    },
  }
</script>
